module.exports = __webpack_public_path__ + "img/m-about3.9b498ebb.png";